<template>
  <!-- 大题型--针对完型填空、阅读理解、选词填空-->
  <div>
    <!-- <div class="que_box" v-for="item in readingsArr" :key="item.orders"> -->
      <!-- 题干 -->
      <div>
        {{ item.orders }}、 <span v-html="item.titleHtml"></span>
        <span>({{ item.score }}分)</span>
      </div>
      <div v-for="small in item.readings" :key="small.orders">
        <!-- 小题 -->
        <div class="small_title">
          <span v-if="subjectType == 10">{{ small.orders }}、</span>
          <span v-html="small.title"></span>
        </div>
        <!-- 选项 -->
        <ul class="option_arr">
          <li v-for="option in small.selects" :key="option.orders">
            <i class="option">{{ option.prefix }}</i
            >{{ option.contents }}
          </li>
        </ul>
        <!-- 答案 -->

        <template v-if="small.types == 3">
          <ul class="ans_ul" v-for="ans in small.programmes" :key="ans.orders">
          <li class="line">
            (空{{ ans.orders }})正确答案 <span></span> ：<span
              class="green_font"
              >{{
                ans.shortAnswers ? ans.shortAnswers : "无"
              }}</span
            >
          </li>
          <li class="line">
            (空{{ ans.orders }})考生作答 <span></span> ：<span
              :class="
                ans.shortAnswers &&
                ans.userAnswers &&
                ans.shortAnswers == ans.userAnswers
                  ? 'green_font'
                  : 'red_font'
              "
              >{{
                ans.userAnswers ? ans.userAnswers : "未作答"
              }}</span
            >
          </li>
        </ul>
        </template>
        <ul class="ans_ul" v-else>
          <li :class="small.types == 5 ? 'block' : 'line'">
            正确答案：<span class="green_font">{{ small.correctAnswer }}</span>
          </li>
          <li :class="small.types == 5 ? 'block' : 'line'">
            考生作答：<span
              :class="
                small.correctAnswer == small.studentAnswer
                  ? 'green_font'
                  : 'red_font'
              "
              >{{ small.studentAnswer ? small.studentAnswer : "未作答" }}</span
            >
          </li>
        </ul>
      </div>
      <!-- 教师评分： -->
      <ul class="teacher_score">
        <li>
          教师评分：
          <el-input
            style="width: 30%"
            type="number"
            v-model="item.teacherScore"
            @input="inputFunc(item.orders, item.teacherScore)"
          >
          </el-input>
          分
        </li>
        <li>
          教师评语：
          <el-input
            style="width: 86%"
            type="text"
            placeholder="请输入本题评语（可以留空）"
            v-model="item.comment"
            maxlength="100"
            show-word-limit
          >
          </el-input>
        </li>
      </ul>
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: "ReadingsType",
  props: {
    // readingsArr: Array,
    item: Object,
    subjectType: Number,
  },
  created() {
    // 大题
    // this.readingsArr.forEach((item) => {
      this.item.titleHtml = this.item.titleHtml.replace(
        /<img/g,
        "<img style='width:80px;height:auto;'"
      );
      //   小题
      if (this.item.readings && this.item.readings.length > 0) {
        this.item.readings.forEach((small) => {
          // 选项
          if(small.types==5){
              // 问答题
                if(small.answerss.userAnswers){
                  small.studentAnswer=small.answerss.userAnswers;
                }else{
                  small.studentAnswer = null;
                }
                small.correctAnswer = small.answerss.shortAnswers;
                console.log(small,'small')
          }else{
            if (small.selects && small.selects.length > 0) {
              //  判断选项数组中的isSelect是否有不同，全部相同都是false说明考生没有选择答案
          
                if (
                  small.selects.some(
                    (e) =>
                      small.selects.filter((e1) => e1.isSelect != e.isSelect)
                        .length > 0
                  )
                ) {
                  // 有作答
                  small.selects.forEach((option) => {
                    if (option.isAnser) {
                      small.correctAnswer = option.prefix;
                    }
                    if (option.isSelect) {
                      small.studentAnswer = option.prefix;
                    }
                  });
                } else {
                  //未作答
                  small.selects.forEach((option) => {
                    if (option.isAnser) {
                      small.correctAnswer = option.prefix;
                    }
                    small.studentAnswer = null;
                  });
                }
              
              
            }
          }
          
        });
      }
    // });
  },
  watch: {
    readingsArr: {
      handler(newValue) {
        this.$emit("change-readings", newValue);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    inputFunc(index, val) {
      // 判断当前是哪个input输入框改变
      // this.readingsArr.map((item) => {
        if (this.item.orders == index) {
          if (val > this.item.score) {
            this.$alert(
              "亲:试题分数不能大于[试题满分]请重新评分！",
              "友情提示",
              {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.item.teacherScore = 0;
                },
              }
            );
            return false;
          }
        }
      // });
    },
  },
};
</script>

<style scoped>
</style>